import script from "./TarManejo.vue?vue&type=script&lang=ts&setup=true"
export * from "./TarManejo.vue?vue&type=script&lang=ts&setup=true"

import "./TarManejo.vue?vue&type=style&index=0&id=759e80bb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-759e80bb"]])

export default __exports__